// Client-side CSV export for the CRM. Injection-safe (SEC-002): values that
// begin with =, +, -, @, tab, or CR are prefixed with ' so spreadsheets treat
// them as inert text instead of executable formulas.
const esc = (v) => {
  let s = String(v ?? "");
  if (/^[=+\-@\t\r]/.test(s)) s = "'" + s;
  return `"${s.replace(/"/g, '""')}"`;
};

// columns: [{ key: "Header label", get: (row) => value }]
export function downloadCsv(filename, columns, rows) {
  const header = columns.map((c) => esc(c.key)).join(",");
  const body = rows.map((r) => columns.map((c) => esc(c.get(r))).join(","));
  const csv = [header, ...body].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
